import React, { useContext, useEffect, useState } from 'react';
import { Alert, Button, Container, Spinner } from 'react-bootstrap';
import { FaArrowRight, FaPrint } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import EmployeeBadgeCard from '../components/EmployeeBadgeCard';
import { AuthContext } from '../context/AuthContext';
import employeeBadgeService from '../services/employeeBadgeService';
import { normalizeRole } from '../utils/rbac';
import '../styles/employee-badges.css';

const EmployeeBadgePrintPage = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const { userId } = useParams();
  const currentRole = normalizeRole(user?.role);
  const canManageBadges = currentRole === 'admin' || currentRole === 'supervisor';

  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!canManageBadges) return;

    let isMounted = true;

    const load = async () => {
      try {
        setLoading(true);
        const response = await employeeBadgeService.getByUser(userId);
        if (!isMounted) return;
        setDetail(response);
      } catch (loadError) {
        if (!isMounted) return;
        setError(loadError.response?.data?.error || 'تعذر تحميل البطاقة للطباعة');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [canManageBadges, userId]);

  useEffect(() => {
    if (!detail?.badge?.exists) return undefined;

    const timer = window.setTimeout(() => {
      window.print();
    }, 500);

    return () => window.clearTimeout(timer);
  }, [detail]);

  if (!canManageBadges) {
    return (
      <Container className="employee-badge-print-page">
        <Alert variant="danger" className="mt-4">لا تملك صلاحية الوصول إلى صفحة الطباعة.</Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container className="employee-badge-print-page">
        <div className="employee-badge-print-loading">
          <Spinner animation="border" />
        </div>
      </Container>
    );
  }

  if (error || !detail) {
    return (
      <Container className="employee-badge-print-page">
        <Alert variant="danger" className="mt-4">{error || 'تعذر تحميل البطاقة'}</Alert>
      </Container>
    );
  }

  return (
    <div className="employee-badge-print-page">
      <div className="employee-badge-print-toolbar d-print-none">
        <Button variant="light" onClick={() => navigate(-1)}>
          <FaArrowRight />
          <span>العودة</span>
        </Button>
        <Button onClick={() => window.print()}>
          <FaPrint />
          <span>طباعة البطاقة</span>
        </Button>
      </div>

      <div className="employee-badge-print-sheet">
        <EmployeeBadgeCard detail={detail} previewLabel="نسخة الطباعة" className="is-print" />
      </div>
    </div>
  );
};

export default EmployeeBadgePrintPage;
